import { Component, HostListener, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calsoft-animated-scrollcard-type3',
  templateUrl: './animated-scrollcard-type3.component.html',
  styleUrls: ['./animated-scrollcard-type3.component.scss']
})
export class AnimatedScrollcardType3Component {

      @Input() data: any;
      @Input() item: any;
      @Input() images: any;
  
  
      loaderHeight: number = 0;
      totalItems: number = 0;
      viewedItems: number = 0;
      public serverPath1 = environment.commonImageApi + '/home/';

      @HostListener('window:scroll', [])
      onWindowScroll() {
        const cards = document.querySelectorAll('.image-section img') as NodeListOf<HTMLElement>;
      
        cards.forEach(img => {
          const rect = img.getBoundingClientRect();
          const windowHeight = window.innerHeight;
      
          if (rect.top >= 0 && rect.top <= windowHeight) {
            // Scroll progress between 0 (top of screen) and 1 (bottom of screen)
            const progress = rect.top / windowHeight;
            const scale = 0.25 + (1 - progress) * 0.8; // zoom from 0.8 to 1
            img.style.transform = `scale(${scale})`;
          } else if (rect.top < 0) {
            img.style.transform = 'scale(1)'; // fully zoomed out
          } else {
            img.style.transform = 'scale(0.8)'; // still not in view
          }
        });
      }
      

      
}
